const DEFAULT_RESERVATION_REFRESH_INTERVAL = 10000;

export function startReservationAutoRefresh(vm, refresh, interval = DEFAULT_RESERVATION_REFRESH_INTERVAL) {
    stopReservationAutoRefresh(vm);
    vm.reservationRefreshTimer = window.setInterval(() => {
        if (!document.hidden) {
            refresh();
        }
    }, interval);
}

export function stopReservationAutoRefresh(vm) {
    if (vm.reservationRefreshTimer) {
        window.clearInterval(vm.reservationRefreshTimer);
        vm.reservationRefreshTimer = null;
    }
}
